import { render, staticRenderFns } from "./AiContentAssistant.vue?vue&type=template&id=271bad2a"
import script from "./AiContentAssistant.vue?vue&type=script&lang=js"
export * from "./AiContentAssistant.vue?vue&type=script&lang=js"
import style0 from "./AiContentAssistant.vue?vue&type=style&index=0&id=271bad2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports